import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@store/authStore.ts';

interface ProtectedRouteProps {
    children: React.ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
    const location = useLocation();
    const { isAuthenticated, checkTokenExpiry, _hasHydrated } = useAuthStore();

    useEffect(() => {
        if (isAuthenticated) {
            checkTokenExpiry();
        }
    }, [location.pathname, isAuthenticated, checkTokenExpiry]);

    if (!_hasHydrated) {
        return null; // 또는 <LoadingSpinner />
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return <>{children}</>;
};

export default ProtectedRoute;
